import { useTranslation } from '@/features/shared/composables/useTranslation'
import { ACCOUNT_TYPE } from '@/features/shared/constants/accountType'
import { PERMISSIONS } from '@/features/shared/constants/permissions'

const t = useTranslation()

export const listingLinksRoutes = [
  {
    path: 'listings/:listingId/links',
    name: 'ListingLinks',
    component: () => import('@/features/listingLinks/views/ListingLinks.vue'),
    meta: {
      mainRouteName: 'Campaigns',
      title: `${t('listing_links')} | Pour Now`,
      permissionIdentifiers: [PERMISSIONS.CAN_VIEW_LISTING_LINKS],
      visibleAccountTypes: [ACCOUNT_TYPE.BRAND],
    },
  },
]
